/**
 * @generated SignedSource<<f7e327769c109ce07268a7796f0a6595>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventAttendeeStatus = "ATTENDING_IN_PERSON" | "ATTENDING_VIRTUAL" | "NOT_ATTENDING" | "PENDING_APPROVAL" | "REJECTED" | "WAITING_IN_PERSON" | "WAITING_VIRTUAL" | "%future added value";
export type EventTicketOrderStatus = "CANCELED" | "PENDING" | "REFUNDED" | "REQUIRES_CAPTURE" | "SUCCEEDED" | "%future added value";
export type StripePaymentIntentStatuses = "CANCELED" | "PROCESSING" | "REQUIRES_ACTION" | "REQUIRES_CAPTURE" | "REQUIRES_CONFIRMATION" | "REQUIRES_PAYMENT_METHOD" | "SUCCEEDED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventScreenAttendCard_event$data = {
  readonly attendeeForm: {
    readonly rowId: string;
  } | null | undefined;
  readonly attendingCount: {
    readonly totalCount: number;
  };
  readonly endAt: string;
  readonly eventAttendeesByRelevance: {
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"EventAttendeesOverlap_eventAttendees">;
  };
  readonly eventTicketingTiers: {
    readonly totalCount: number;
  };
  readonly myAttendance: {
    readonly formSubmission: {
      readonly id: string;
    } | null | undefined;
    readonly paymentStatus: StripePaymentIntentStatuses | null | undefined;
    readonly visibleStatus: EventAttendeeStatus;
  } | null | undefined;
  readonly myTicketOrder: {
    readonly status: EventTicketOrderStatus;
  } | null | undefined;
  readonly prettyUrl: string;
  readonly slug: string;
  readonly startAt: string;
  readonly viewerCanManage: boolean | null | undefined;
  readonly waitingCount: {
    readonly totalCount: number;
  };
  readonly " $fragmentSpreads": FragmentRefs<"EventAttendButtonNew_event" | "EventScreenInviteDialog_event">;
  readonly " $fragmentType": "EventScreenAttendCard_event";
};
export type EventScreenAttendCard_event$key = {
  readonly " $data"?: EventScreenAttendCard_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventScreenAttendCard_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenAttendCard_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "status": {
              "in": [
                "ATTENDING_IN_PERSON",
                "ATTENDING_VIRTUAL",
                "WAITING_IN_PERSON",
                "WAITING_VIRTUAL"
              ]
            }
          }
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 8
        }
      ],
      "concreteType": "EventAttendeesConnection",
      "kind": "LinkedField",
      "name": "eventAttendeesByRelevance",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventAttendeesOverlap_eventAttendees"
        }
      ],
      "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
    },
    {
      "alias": "attendingCount",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "status": {
              "in": [
                "ATTENDING_IN_PERSON",
                "ATTENDING_VIRTUAL"
              ]
            }
          }
        }
      ],
      "concreteType": "EventAttendeesConnection",
      "kind": "LinkedField",
      "name": "eventAttendees",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
    },
    {
      "alias": "waitingCount",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "status": {
              "in": [
                "WAITING_IN_PERSON",
                "WAITING_VIRTUAL"
              ]
            }
          }
        }
      ],
      "concreteType": "EventAttendeesConnection",
      "kind": "LinkedField",
      "name": "eventAttendees",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanManage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendee",
      "kind": "LinkedField",
      "name": "myAttendance",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "visibleStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paymentStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FormSubmission",
          "kind": "LinkedField",
          "name": "formSubmission",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventTicketOrder",
      "kind": "LinkedField",
      "name": "myTicketOrder",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Form",
      "kind": "LinkedField",
      "name": "attendeeForm",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SORT_ORDER_ASC",
            "CREATED_AT_ASC"
          ]
        }
      ],
      "concreteType": "EventTicketingTiersConnection",
      "kind": "LinkedField",
      "name": "eventTicketingTiers",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "eventTicketingTiers(orderBy:[\"SORT_ORDER_ASC\",\"CREATED_AT_ASC\"])"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventAttendButtonNew_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventScreenInviteDialog_event"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "c9d9a48de5214908fc04b49bf3923c44";

export default node;
